import type {
  BoundaryMultiPolygon, ZoomLevel,
} from '~/store/boundaryItems/boundaryItems.state';

export const getMostDetailedBoundaryMultiPolygon = (paths: Map<ZoomLevel, BoundaryMultiPolygon>) => {
  const zoomLevels = Array.from(paths.keys());

  if (!zoomLevels.length) {
    return undefined;
  }

  return paths.get(Math.max(...zoomLevels));
};
